import React from "react";
import "./Hero.css";
import { FaLandmark } from "react-icons/fa";
import heroImage from "../../images/moises.jpeg";

const Hero = () => {
  return (
    <section className="hero" id="hero" aria-label="Apresentação do escritório">
      <div className="hero-content">
        <div className="hero-text">
          <div className="hero-title-box">
            <FaLandmark className="hero-icon" aria-hidden="true" />
            <h1>Advocacia especializada em Direito do Trabalho</h1>
          </div>

          <p className="descricao">
            Advocacia preventiva, consultiva e contenciosa com atuação
            estratégica em todo o território nacional.
          </p>
        </div>

        <div className="hero-image">
          <img
            src={heroImage}
            alt="Yara Catarina Carreira, advogada criminalista"
            loading="eager"
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
